import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ToggleStrokeAction extends AbstractProvidedClass {
    newState;

    constructor(provider, appearance, strokeColor, useFill) {
        super(provider);

        this.appearance = appearance;
        this.strokeColor = strokeColor;
        this.newState = useFill;
    }

    finish() {
        this.appearance.strokeColor = this.newState ? this.p.color(this.strokeColor) : null;
        this.appearance.parent.row.updateImg();
        this.actions.finish();
    }

    undo() {
        this.appearance.strokeColor = !this.newState ? this.p.color(this.strokeColor) : null;
        this.appearance.parent.row.updateImg();
    }

    redo() {
        this.appearance.strokeColor = this.newState ? this.p.color(this.strokeColor) : null;
        this.appearance.parent.row.updateImg();
    }
}
